import React from "react";
import styled from "styled-components";
import {subduedTextColour} from "../../../../style/styleConsts";
import {timeBetween} from "../../idea/timeOpenCalculator";
import {useSelector} from "react-redux";
import {Clock, Instant} from "js-joda";
import {ActivityTopRow} from "./ActivityTopRow";

const Container = styled.div`
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 10px;
    padding-right: 10px;
`;

const ExpiryMessage = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
    color: ${subduedTextColour};
    white-space: nowrap;
    font-weight: bold;
`;

const PortfolioName = styled.div`
    margin-top: 3px;
    font-weight: bold;
    font-size: 14px;
`;

const Author = styled.div`
    margin-top: 3px;
    font-size: 10px;
`;

const Message = styled.span`
    margin-top: 3px;
    color: ${subduedTextColour};
`;

export const PortfolioMessageAction = ({action}) => {
    const clock = useSelector(({clock}) => clock || Clock.systemDefaultZone());
    const now = Instant.now(clock).toString();
    const expiry = action.expiration + "T23:59:59Z";

    let expiryMessage;
    if (action.removed) {
        expiryMessage = `Removed`;
    } else if (expiry > now) {
        expiryMessage = `Expires in ${timeBetween(now, expiry, clock)}`;
    } else {
        expiryMessage = `Expired`;
    }

    return <Container className="t-portfolio-message">
        <ActivityTopRow name="Client Message" dateTime={action.dateTime}/>
        <ExpiryMessage className="t-expiry-message">{expiryMessage}</ExpiryMessage>
        <PortfolioName className="t-header">{action.portfolioName} message</PortfolioName>
        <Author className="t-author">{action.author} says:</Author>
        <Message className="t-message">{action.message}</Message>
    </Container>
};